import { Tooltip } from '@leland-dev/leland-ui-library';
import React, { type FC, type ReactNode } from 'react';

import { type ServicesDescriptionCoachingFocusFragment } from './__generated-gql-types__/ServicesDescription.generated';

interface Props {
  className?: string;
  services: Possible<ServicesDescriptionCoachingFocusFragment[]>;
}

export const ServicesDescription: FC<Props> = ({ className, services }) => {
  if (!services?.length) {
    return null;
  }

  const prefix = 'Get help with';
  const formattedCoachingFocuses = services.map((c) => c.name);
  const numberVisibleCoachingFocuses =
    formattedCoachingFocuses.length > 3 ? 2 : 3;
  const visibleCoachingFocuses = formattedCoachingFocuses.slice(
    0,
    numberVisibleCoachingFocuses,
  );
  const hiddenCoachingFocuses =
    formattedCoachingFocuses.length > numberVisibleCoachingFocuses
      ? formattedCoachingFocuses.slice(numberVisibleCoachingFocuses)
      : [];

  let content: ReactNode;
  if (hiddenCoachingFocuses.length > 0) {
    content = (
      <>
        {prefix} {visibleCoachingFocuses.join(', ')}, and{' '}
        <Tooltip content={hiddenCoachingFocuses.join(', ')}>
          <span className="link inline underline">more</span>
        </Tooltip>
        .
      </>
    );
  } else {
    if (visibleCoachingFocuses.length > 1) {
      visibleCoachingFocuses[visibleCoachingFocuses.length - 1] = `and ${
        visibleCoachingFocuses[visibleCoachingFocuses.length - 1]
      }`;
    }

    content = `${prefix} ${visibleCoachingFocuses.join(
      visibleCoachingFocuses.length > 2 ? ', ' : ' ',
    )}.`;
  }

  return <p className={className}>{content}</p>;
};
